import { CircleCheck, ExternalLink } from 'lucide-react';
import { draftWhen } from '../../../lib/draft-preview';
import { useTranslation } from '../../../lib/i18n';
import type { TaskContentView } from '../../../lib/task-content-view';
import { Button } from '../ui';
import styles from './TaskContentSection.module.css';

const DELIVERED_AT: Record<TaskContentView['kind'], string> = { social: 'tasks.plan.postedAt', email: 'draftPreview.sentAt', blog: 'draftPreview.publishedAt' };
const DELIVERED: Record<TaskContentView['kind'], string> = { social: 'calendar.post.published', email: 'calendar.post.sent', blog: 'calendar.post.blogPublished' };

export function DeliveredOutcome({
  kind,
  at,
  url,
  locale,
  onViewPost,
}: {
  kind: TaskContentView['kind'];
  at?: string | null;
  url?: string | null;
  locale: string | undefined;
  onViewPost: (url: string) => void;
}) {
  const { t } = useTranslation();
  return (
    <span className={styles.outcome} data-testid="taskContentPosted">
      <span className={styles.line}>
        <CircleCheck size={14} aria-hidden className={styles.glyph} />
        {at ? t(DELIVERED_AT[kind], { when: draftWhen(at, locale) }) : t(DELIVERED[kind])}
      </span>
      {url && (
        <Button size="small" variant="outlined" startIcon={<ExternalLink size={16} aria-hidden />} onClick={() => onViewPost(url)} data-testid="taskViewPost">
          {t('draftPreview.view')}
        </Button>
      )}
    </span>
  );
}
